import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  delete open position 
export const DeleteOpenPosition = createSlice({
  name: "DeleteOpenPosition",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    delete_DeleteOpenPosition: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_delete_DeleteOpenPosition: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_delete_DeleteOpenPosition: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.switchResponse = true;
    },
    delete_DeleteOpenPosition_is_success: (state, action) => {
      state.isSuccess = false;
    },
    false_switchDeleteOpenPosition_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default DeleteOpenPosition.reducer;
export const {
  delete_DeleteOpenPosition,
  success_api_call_delete_DeleteOpenPosition,
  failure_api_call_delete_DeleteOpenPosition,
  delete_DeleteOpenPosition_is_success,
  false_switchDeleteOpenPosition_response
} = DeleteOpenPosition.actions;
